/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

var wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    offset: 200,
    mobile: false,
    live: true
});
wow.init();

var swiper1 = new Swiper(".partner_lists", {
    slidesPerView: 14,
    spaceBetween: 10,
    loop: true, // 设置为true 则开启loop(无限循环)模式
    freeMode: true, //【关键】设置为true则变为free模式
    speed:2000, //【关键】匀速时间
    autoplay: { // 自动播放
         delay: 0, //【关键】自动切换的时间间隔，单位ms
    },
    // navigation: {
    //     nextEl: ".swiper-button-next-case",
    //     prevEl: ".swiper-button-prev-case",
    // },
    // slidesOffsetBefore: -250,
    // autoplay: false,
    breakpoints: {
        1281: {
          slidesPerView: 14,
          spaceBetween: 10,
        },
        1280: {
          slidesPerView: 14,
          spaceBetween: 10,
        },
        1025: {
          slidesPerView: 12,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 10,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 10,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 8,
          spaceBetween: 10,
        },
        540: {
          slidesPerView: 6,
          spaceBetween: 10,
        },
        414: {
          slidesPerView: 6,
          spaceBetween: 10,
        },
        375: {
          slidesPerView: 6,
          spaceBetween: 10,
        },
        320: {
          slidesPerView: 6,
          spaceBetween: 10,
        }
      },
  });

var swiper2 = new Swiper(".partner_lists2", {
    slidesPerView: 16,
    spaceBetween: 10,
    loop: true, // 设置为true 则开启loop(无限循环)模式
    freeMode: true, //【关键】设置为true则变为free模式
    speed:2000, //【关键】匀速时间
    autoplay: { // 自动播放
         delay: 0, //【关键】自动切换的时间间隔，单位ms
    },
    // navigation: {
    //     nextEl: ".swiper-button-next-case",
    //     prevEl: ".swiper-button-prev-case",
    // },
    // slidesOffsetBefore: -250,
    // autoplay: false,
    breakpoints: {
        1281: {
          slidesPerView: 16,
          spaceBetween: 10,
        },
        1280: {
          slidesPerView: 16,
          spaceBetween: 10,
        },
        1025: {
          slidesPerView: 14,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 12,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 12,
           spaceBetween: 10,
        },
        640: {
          slidesPerView: 10,
          spaceBetween: 10,
        },
        540: {
          slidesPerView: 6,
          spaceBetween: 10,
        },
        414: {
          slidesPerView: 6,
          spaceBetween: 10,
        },
        375: {
          slidesPerView: 6,
          spaceBetween: 10,
        },
        320: {
          slidesPerView: 6,
          spaceBetween: 10,
        }
      },
  });

$(document).ready(function(){
  // 假设我们要更改的单词是 "sample"
  $('.shopify-section--featured-collections .h2').html(function(_, txt) {
    return txt.replace(/Digital Assets/gi, '<span class="section_head_color">Digital Assets</span>');
  });
  $('.pao_part_one h3').html(function(_, txt) {
    return txt.replace(/Multi-Chain/gi, '<span class="section_head_color">Multi-Chain</span>');
  });
  $('.home_image_text .h3').html(function(_, txt) {
    return txt.replace(/Cross-Platform/gi, '<span class="section_head_color">Cross-Platform</span>');
  });
  $('.section_voices_head .h2').html(function(_, txt) {
    return txt.replace(/Voices/gi, '<span class="section_head_color">Voices</span>');
  });
  $('.single_image_text_box .h2').html(function(_, txt) {
    return txt.replace(/military-grade/gi, '<span class="section_head_color">military-grade</span>');
  });
  $('.single_image_text_box .h2').html(function(_, txt) {
    return txt.replace(/军用芯片/gi, '<span class="section_head_color">军用芯片</span>');
  });  
  $('.single_image_text_box22 .h2').html(function(_, txt) {
    return txt.replace(/Simple, Stable, Secure/gi, '<span class="section_head_color">Simple, Stable, Secure</span><br>');
  });
  $('.single_image_text_box22 .h2').html(function(_, txt) {
    return txt.replace(/简单、稳定、安全/gi, '<span class="section_head_color">简单、稳定、安全</span><br>');
  });
  $('.single_image_text_box22 .h2').html(function(_, txt) {
    return txt.replace(/Advanced, Private, Secure/gi, '<span class="section_head_color">Advanced, Private, Secure</span><br>');
  });
  $('.single_image_text_box22 .h2').html(function(_, txt) {
    return txt.replace(/進階、私密、安全。/gi, '<span class="section_head_color">進階、私密、安全。</span><br>');
  });  
  $('.single_image_text_box22 .h2').html(function(_, txt) {
    return txt.replace(/Simple, Reliable/gi, '<span class="section_head_color">Simple, Reliable</span><br>');
  });
  $('.single_image_text_box22 .h2').html(function(_, txt) {
    return txt.replace(/简单，踏实/gi, '<span class="section_head_color">简单，踏实</span><br>');
  });  
  $('.this_way_section .h2').html(function(_, txt) {
    return txt.replace(/This Way/gi, '<span class="section_head_color">This Way</span>');
  });
});
var swiper3 = new Swiper(".proven_lists", {
    slidesPerView: 5,
    spaceBetween: 0,
    loop: true, // 设置为true 则开启loop(无限循环)模式
    freeMode: true, //【关键】设置为true则变为free模式
    speed:10000, //【关键】匀速时间
    autoplay: { // 自动播放
         delay: 0, //【关键】自动切换的时间间隔，单位ms
    },
    // navigation: {
    //     nextEl: ".swiper-button-next-case",
    //     prevEl: ".swiper-button-prev-case",
    // },
    // slidesOffsetBefore: -250,
    // autoplay: false,
    breakpoints: {
        1281: {
          slidesPerView: 5,
        },
        1280: {
          slidesPerView: 5,
        },
        1025: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
        640: {
          slidesPerView: 2,
        },
        540: {
          slidesPerView: 2,
        },
        414: {
          slidesPerView: 2,
        },
        375: {
          slidesPerView: 2,
        },
        320: {
          slidesPerView: 2,
        }
      },
  });


var swiper4 = new Swiper(".mb_icon_bar", {
    slidesPerView: 4,
    spaceBetween: 0,
    speed:20000, //【关键】匀速时间
    autoplay: { // 自动播放
         delay: 5000, //【关键】自动切换的时间间隔，单位ms
    },
    autoplay: true,
    breakpoints: {
        1281: {
          slidesPerView: 4,
        },
        1280: {
          slidesPerView: 3,
        },
        1025: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        640: {
          slidesPerView: 2,
        },
        540: {
          slidesPerView: 2,
        },
        414: {
          slidesPerView: 2,
        },
        375: {
          slidesPerView: 2,
        },
        320: {
          slidesPerView: 1,
        }
      }
  });

var swiper5 = new Swiper(".customization_lists", {
    slidesPerView: 5,
    spaceBetween: 25,
    loop: true, // 设置为true 则开启loop(无限循环)模式
    freeMode: true, //【关键】设置为true则变为free模式
    speed:10000, //【关键】匀速时间
    autoplay: { // 自动播放
         delay: 0, //【关键】自动切换的时间间隔，单位ms
    },
    // navigation: {
    //     nextEl: ".swiper-button-next-case",
    //     prevEl: ".swiper-button-prev-case",
    // },
    // slidesOffsetBefore: -250,
    // autoplay: false,
    breakpoints: {
        1281: {
          slidesPerView: 5,
          spaceBetween: 25,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        1025: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        540: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        414: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        375: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        }
      },
  });

      
!function(a,n){"function"==typeof define&&define.amd?define(n):"object"==typeof exports?module.exports=n(require,exports,module):a.CountUp=n()}(this,function(a,n,t){var e=function(a,n,t,e,i,r){function o(a){a=a.toFixed(l.decimals),a+="";var n,t,e,i,r,o;if(n=a.split("."),t=n[0],e=n.length>1?l.options.decimal+n[1]:"",l.options.useGrouping){for(i="",r=0,o=t.length;r<o;++r)0!==r&&r%3===0&&(i=l.options.separator+i),i=t[o-r-1]+i;t=i}
return l.options.numerals.length&&(t=t.replace(/[0-9]/g,function(a){return l.options.numerals[+a]}),e=e.replace(/[0-9]/g,function(a){return l.options.numerals[+a]})),l.options.prefix+t+e+l.options.suffix}
function u(a,n,t,e){return t*(-Math.pow(2,-10*a/e)+1)*1024/1023+n}
function s(a){return "number"==typeof a&&!isNaN(a)}
var l=this;if(l.version=function(){return "1.9.2"},l.options={useEasing:!0,useGrouping:!0,separator:",",decimal:".",easingFn:u,formattingFn:o,prefix:"",suffix:"",numerals:[]},r&&"object"==typeof r)for(var m in l.options)r.hasOwnProperty(m)&&null!==r[m]&&(l.options[m]=r[m]);""===l.options.separator?l.options.useGrouping=!1:l.options.separator=""+l.options.separator;for(var d=0,c=["webkit","moz","ms","o"],f=0;f<c.length&&!window.requestAnimationFrame;++f)window.requestAnimationFrame=window[c[f]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[c[f]+"CancelAnimationFrame"]||window[c[f]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(a,n){var t=(new Date).getTime(),e=Math.max(0,16-(t-d)),i=window.setTimeout(function(){a(t+e)},e);return d=t+e,i}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(a){clearTimeout(a)}),l.initialize=function(){return!!l.initialized||(l.error="",l.d="string"==typeof a?document.getElementById(a):a,l.d?(l.startVal=Number(n),l.endVal=Number(t),s(l.startVal)&&s(l.endVal)?(l.decimals=Math.max(0,e||0),l.dec=Math.pow(10,l.decimals),l.duration=1e3*Number(i)||2e3,l.countDown=l.startVal>l.endVal,l.frameVal=l.startVal,l.initialized=!0,!0):(l.error="[CountUp] startVal ("+n+") or endVal ("+t+") is not a number",!1)):(l.error="[CountUp] target is null or undefined",!1))},l.printValue=function(a){var n=l.options.formattingFn(a);"INPUT"===l.d.tagName?this.d.value=n:"text"===l.d.tagName||"tspan"===l.d.tagName?this.d.textContent=n:this.d.innerHTML=n},l.count=function(a){l.startTime||(l.startTime=a),l.timestamp=a;var n=a-l.startTime;l.remaining=l.duration-n,l.options.useEasing?l.countDown?l.frameVal=l.startVal-l.options.easingFn(n,0,l.startVal-l.endVal,l.duration):l.frameVal=l.options.easingFn(n,l.startVal,l.endVal-l.startVal,l.duration):l.countDown?l.frameVal=l.startVal-(l.startVal-l.endVal)*(n/l.duration):l.frameVal=l.startVal+(l.endVal-l.startVal)*(n/l.duration),l.countDown?l.frameVal=l.frameVal<l.endVal?l.endVal:l.frameVal:l.frameVal=l.frameVal>l.endVal?l.endVal:l.frameVal,l.frameVal=Math.round(l.frameVal*l.dec)/l.dec,l.printValue(l.frameVal),n<l.duration?l.rAF=requestAnimationFrame(l.count):l.callback&&l.callback()},l.start=function(a){l.initialize()&&(l.callback=a,l.rAF=requestAnimationFrame(l.count))},l.pauseResume=function(){l.paused?(l.paused=!1,delete l.startTime,l.duration=l.remaining,l.startVal=l.frameVal,requestAnimationFrame(l.count)):(l.paused=!0,cancelAnimationFrame(l.rAF))},l.reset=function(){l.paused=!1,delete l.startTime,l.initialized=!1,l.initialize()&&(cancelAnimationFrame(l.rAF),l.printValue(l.startVal))},l.update=function(a){if(l.initialize()){if(a=Number(a),!s(a))return void(l.error="[CountUp] update() - new endVal is not a number: "+a);l.error="",a!==l.frameVal&&(cancelAnimationFrame(l.rAF),l.paused=!1,delete l.startTime,l.startVal=l.frameVal,l.endVal=a,l.countDown=l.startVal>l.endVal,l.rAF=requestAnimationFrame(l.count))}},l.initialize()&&l.printValue(l.startVal)};return e});

    $(function(){
        var countCXArr = [];
        var countCX=function (){
            $('.numCounts').each(function(i, dom) {
                if(countCXArr[i] && countCXArr[i] === true){
                    return;
                }
                var sT;
                var ncTop;
                sT = $(window).scrollTop();
                ncTop = $(dom).offset().top;
                var id,decimals, startVal, endVal, duration; 
                if (sT > ncTop-$(window).height() && sT < ncTop) {
                    $(dom).find('.numCX').each(function(){
                        id=$(this).attr('id');
                        decimals = $(this).attr('data-decimals'),
                        startVal = $(this).attr('data-startVal'),
                        endVal = $(this).attr('data-endVal'),
                        duration = $(this).attr('data-speed'); 
                        new CountUp(id, startVal, endVal, decimals, duration, {
                            useEasing: true,//效果
                            separator: ''//数字分隔符
                        }).start();// target：目标元素id, startVal：你想要开始的值, endVal：你想要到达的值, decimals：小数位数，默认值为0, duration：动画持续时间为秒，默认值为2, options：选项的可选对象
                        countCXArr[i] = true;
                    })         
                }
            }) 
        }
        countCX();	
        $(window).on("scroll",function() {
            countCX();	
        })	
    });

$("#compare").click(function(){
  $(".compare_content").toggle(500);
});
$("#compare").click(function(){
    $(this).toggleClass('active');
});
var originalText = $('#compare span').text();
var newText = 'Pack up';
$('#compare').click(function(){
    if($(this).find('span').text() === newText) {
        $(this).find('span').text(originalText);
    } else {
        $(this).find('span').text(newText);
    }
});

$("#compare-cn").click(function(){
  $(".compare_content").toggle(500);
});
$("#compare-cn").click(function(){
    $(this).toggleClass('active');
});
var originalTextcn = $('#compare-cn span').text();
var newTextcn = '收起';
$('#compare-cn').click(function(){
    if($(this).find('span').text() === newTextcn) {
        $(this).find('span').text(originalTextcn);
    } else {
        $(this).find('span').text(newTextcn);
    }
});

var swiper = new Swiper('.showcase', {
    autoplay: {
    delay: 2500,
    disableOnInteraction: false,
    },
    speed: 700,
    pagination: {
        el: ".swiper-pagination",
        clickable: true, 
    }
});

$('.insides_item h3>a').smoothScroll({
   offset: -220
});
$('.mega-menu-link').smoothScroll({
   offset: -220
});
$('.mega-menu__image-push').smoothScroll({
   offset: -220
});
const modals = new Modals({
    allowMultiple: true
});
$('.close_bar').click(function(){
  $(this).parent().hide();
  $('.slideshow__image').addClass('close');
});

var swiper6 = new Swiper(".announcement_swiper", {
    slidesPerView: 1,
    loop: true, // 设置为true 则开启loop(无限循环)模式
    freeMode: true, //【关键】设置为true则变为free模式
    speed:10000, //【关键】匀速时间
    centeredSlides: true, // slide居中显示
    spaceBetween: 50, // 设置间距
    slideToClickedSlide: true, // 点击slide时，该slide会居中显示
    autoplay: {
        delay: 0 // 设置为0以取消延迟，即无等待时间切换幻灯片
    }
});

var swiper7 = new Swiper(".store_swiper", {
  // loop: true,
  slidesPerView: 7,
  spaceBetween: 30,
  autoplay: true,
  breakpoints: {
      1441: {
        slidesPerView: 7,
        spaceBetween: 30,
      },
      1440: {
        slidesPerView: 6,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      580: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      414: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      375: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      320: {
        slidesPerView: 2,
        spaceBetween: 15,
      }
    }
});